{
    "ServiceMessages_Timeline_Title": "Service- und Wartungsmeldungen",
    "NAME": "ServiceMessagesLanguage"
}